import { Injectable, OnDestroy } from '@angular/core';
import { ConfigStore, Configs } from '@app/app-configs/config-store';
import { UserService } from '@app/app-state/user.service';

declare global {
	interface ZohoDeskAsapApi {
		on(event: string, callback: () => void): void;
		set(key: string, value: unknown): void;
		invoke(action: string, parameters?: unknown): void;
	}

	interface Window {
		ZohoDeskAsap: ZohoDeskAsapApi;
		ZohoDeskAsapReady: (callback:()=>void)=>void;
		ZohoDeskAsap__asyncalls: Array<()=>void>;
		ZohoDeskAsapReadyStatus: boolean;
		ZohoDeskAsapInit: () => { hideLauncherIcon: boolean };
	}
}

@Injectable({
	providedIn: 'root',
})
export class SupportButtonService implements OnDestroy{
	private isHidden=false;
	private isOpen=false;
	public get initialized(){return !!window.ZohoDeskAsap?.invoke}
	public get visible(){return !this.isHidden}
	private zohoDeskDetails=ConfigStore.get<Configs['support']['supportDeskDetails']>('support.supportDeskDetails');

	constructor(
		private readonly userService:UserService
	){
		// Hiding support button temporarily for other than Strayos vendor
		if(this.zohoDeskDetails){
			this.initializeZohoDeskAsap();
		}
	}

	ngOnDestroy(): void {
		throw new Error('Method not implemented.');
	}

	private initializeZohoDeskAsap(){
		window.ZohoDeskAsapReady=(callback)=>{
			const asyncCalls=window.ZohoDeskAsap__asyncalls=window.ZohoDeskAsap__asyncalls||[];
			if(window.ZohoDeskAsapReadyStatus){
				if(callback)
					asyncCalls.push(callback);

				asyncCalls.forEach((cb)=>{
					if(cb) cb();
				});
				window.ZohoDeskAsap__asyncalls=null;
			}else{
				if(callback)
					asyncCalls.push(callback);
			}
		}

		window.ZohoDeskAsapInit=()=>{
			return {
				hideLauncherIcon: true
			}
		}

		// set up the event listener for forms prefill
		window.ZohoDeskAsapReady(()=>{
			window.ZohoDeskAsap.on("onAppOpen", ()=>{
				const userEmail=this.userService?.user?.email || '';
				const userName=this.userService?.user?.firstName || '' + ' ' + this.userService?.user?.lastName || '';
				const sourceUrl=window.location.href;
				window.ZohoDeskAsap.set("ticket.form.prefillValues", {
					[`${this.zohoDeskDetails.departmentId}&&&${this.zohoDeskDetails.layoutId}`]: {
						'contactId': {
							defaultValue: userName
						},
						'email': {
							defaultValue: userEmail
						},
						'cf_source_url': {
							defaultValue: sourceUrl,
							isHidden: true
						}
					}
				});
				this.isOpen=true;
			});

			window.ZohoDeskAsap.on("onAppClose", ()=>{
				this.isOpen=false;
			});
		});

		const script=document.createElement('script');
		script.type='text/javascript';
		script.id='zohodeskasapscript';
		script.defer=true;
		script.src=`https://desk.zoho.com/portal/api/web/asapApp/${this.zohoDeskDetails.widgetId}?orgId=${this.zohoDeskDetails.orgId}`;

		document.getElementsByTagName('body')[0].appendChild(script);
	}

	public positionRelativeToPoint(x:number, y:number){
		// TODO: Implement this function
	}

	public toggle(){
		window.ZohoDeskAsap?.invoke(this.isOpen?'close':'open');
	}

	public openTicketForm(){
		if(this.isOpen){
			window.ZohoDeskAsap?.invoke("close");
		}else{
			window.ZohoDeskAsap?.invoke("routeTo",{
				page:"ticket.form",
				parameters:{
					departmentId:this.zohoDeskDetails.departmentId,
					layoutId:this.zohoDeskDetails.layoutId,
				}
			});
		}
	}

	public hide(){
		this.isHidden=true;
	}

	public show(){
		this.isHidden=false;
	}
}
